import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ExternalLink } from "lucide-react";
import { Overline } from "@/components/Reveal";

export default function Hosts() {
    return (
        <div data-testid="hosts-page" className="min-h-screen bg-night-deep text-white font-body px-6 sm:px-12 lg:px-20 py-10">
            <div className="grain-overlay" aria-hidden="true" />
            <div className="flex items-center justify-between">
                <p className="font-display italic text-2xl tracking-wide text-gold">
                    Hollywood <span className="not-italic text-white/60 text-sm align-super">'26</span>
                </p>
                <Link
                    data-testid="hosts-back-link"
                    to="/"
                    className="inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-white/50 hover:text-gold transition-colors duration-300"
                >
                    <ArrowLeft size={13} strokeWidth={1.5} /> Retour au site
                </Link>
            </div>

            <div className="flex items-center justify-center min-h-[70vh]">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    className="w-full max-w-xl text-center"
                >
                    <div className="flex items-center justify-center gap-5 mb-10">
                        <span className="h-px w-14 bg-gold/50" />
                        <span className="text-gold text-sm">✦</span>
                        <span className="h-px w-14 bg-gold/50" />
                    </div>
                    <Overline className="text-center">Espace des hôtes</Overline>
                    <h1 className="mt-4 font-display text-4xl sm:text-5xl tracking-tight">
                        Le registre a <em className="text-gold">déménagé.</em>
                    </h1>
                    <p className="mt-8 text-base font-light leading-relaxed text-white/60 max-w-md mx-auto">
                        Les réponses des invités sont désormais recueillies et gérées
                        directement dans votre dashboard Tally — réponses en temps réel,
                        notifications et export inclus.
                    </p>
                    <a
                        data-testid="hosts-tally-link"
                        href="https://tally.so"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group relative mt-12 inline-block overflow-hidden border border-gold/60 px-10 py-4 text-xs tracking-[0.3em] uppercase text-gold transition-colors duration-500 hover:text-night-deep"
                    >
                        <span className="absolute inset-0 bg-gold translate-y-full transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:translate-y-0" />
                        <span className="relative inline-flex items-center gap-3">
                            Ouvrir le dashboard Tally <ExternalLink size={14} strokeWidth={1.5} />
                        </span>
                    </a>
                </motion.div>
            </div>
        </div>
    );
}
